import styled from 'styled-components'

import theme from 'theme_'
import { Font12, Font14 } from 'components/Typography'

const { colors } = theme

export const MobileJobTableItem = styled.div`
  width: 100%;
  font-weight: 400;
  color: ${colors.otterWarmBlack};
  border-radius: 15px;
  padding: 16px 20px;
  box-shadow: 10px 10px 50px rgba(0, 0, 0, 0.05);
  background: ${colors.white};

  & + & {
    margin-top: 12px;
  }
`

export const MobileJobTableItemHeader = styled.header<{ dark?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${theme.spacing.xs};
  color: ${(p) => (p.dark ? colors.otterWarmBlack : colors.moreGrey)};
  ${Font14}
`

export const MobileJobTableItemMain = styled.main`
  margin-bottom: 20px;
`

export const MobileJobTableItemMainInner = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${theme.spacing.md};
`

export const MobileJobTableItemInfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin: ${theme.spacing.sm} 0;
`

export const MobileJobTableItemNarrowRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: ${theme.spacing.base};
`

export const MobileJobTableItemInfoRight = styled.div`
  ${Font14};
  text-align: right;
`

export const MobileJobTableItemInfoTitle = styled.div`
  color: ${theme.colors.darkeyGrey};
  ${Font12}
`

export const MobileJobTableItemVersion = styled.div`
  font-weight: 700;
`

export const MobileJobTableItemTitleWrapper = styled.div`
  margin-left: 5px;
`

export const MobileJobTableItemPlanWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: ${theme.spacing.md};
`

export const MobileJobTableItemHomeName = styled.div`
  font-size: 16px;
  font-weight: 700;
`
